// Live 'livechat' events over the existing /api/ws/ringing socket.
import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const wsBase = () => (process.env.REACT_APP_BACKEND_URL || '').replace(/^http/, 'ws');

export const useLiveChatSocket = (onEvent) => {
  const { user, token } = useAuth();
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    const domainId = user?.domain_id;
    if (!domainId || !token) return undefined;
    let cancelled = false;
    let ws;
    let timer;
    const connect = () => {
      ws = new WebSocket(`${wsBase()}/api/ws/ringing?domain_id=${encodeURIComponent(domainId)}&token=${encodeURIComponent(token)}`);
      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          if (data?.type === 'livechat') cbRef.current?.(data);
        } catch { /* ignore */ }
      };
      ws.onclose = () => { if (!cancelled) timer = setTimeout(connect, 4000 + Math.random() * 2000); };
      ws.onerror = () => { try { ws.close(); } catch { /* noop */ } };
    };
    connect();
    return () => {
      cancelled = true;
      clearTimeout(timer);
      try { ws?.close(); } catch { /* noop */ }
    };
  }, [user?.domain_id, token]);
};
